module.exports = __webpack_public_path__ + "static/media/text.ecb9e0e2.svg";